import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { HandymanAppState } from "../../configuration/redux/reducers"; 
import { getAuthData } from "../../helpers/localStorageHelpers";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // If you're storing an auth boolean in Redux, replace this
  // with the correct selector or logic from your AuthProvider.
  const isAuthenticated = getAuthData()

  // If the user is not authenticated, redirect to "sign-in"
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  // Otherwise, allow access
  return <>{children}</>;
};

export default ProtectedRoute;